<style scoped lang="scss">
.uk-card-primary {
  color: white;
  background-color: #0f7ae5;
  padding: 20px;
  font-size: 1.2em;
  border-radius: 6px;
  margin-left: 40px;
  margin-right: 40px;
}
</style>

<template>
  <div class="uk-grid" id="income-question">
    <div class="uk-width-1-1 uk-margin-large-bottom">
      <prequal-address-form
        :states="states"
        :counties="counties"
        :is-homeless="isHomeless"
        :program="program"
        @updated="updatePropertyAddress"
      ></prequal-address-form>
      <div v-if="qualifiesForProxy" class="uk-card uk-card-primary uk-margin-top">

          Your home's location qualifies your income under the Qualified Census Tract.

      </div>
    </div>

    <div class="uk-width-1-1" v-if="(env.LANG_KEY != 'clackamas_' || (options && options.showIncome)) && (!options || options.showIncomeTable == true)">
      <div v-if="propertyAddress.county_id">
        <table class="uk-table uk-table-striped">
          <thead>
            <tr>
              <th class="uk-text-uppercase">
                {{ __("global.household_size") }}
              </th>
              <th class="uk-text-right">
                {{ __("global.max_pre_tax") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(incomeLimit, i) in incomeLimits" v-if="incomeLimit > 0">
              <td>
                {{ i }}
              </td>
              <td class="uk-text-right">
                {{ incomeLimit | formatMoney }}
              </td>
            </tr>
          </tbody>
        </table>
        <h3 class="uk-text-center">
          <span
            v-if="incomeText != ''"
            v-html="incomeText"
          ></span>
          <span v-else>{{ __("landing.is_hh_combined_combined") }}</span>
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import PrequalAddressForm from "./PrequalAddressForm";
import {mapState} from "vuex";

export default {
  name: "IncomeQuestion",
  components: { PrequalAddressForm },
  props: {
    program: Object,
    states: Array,
    counties: Array,
    isHomeless: Boolean,
    options: {
      type: Object,
      default: () => {
        return {
          showIncome: true,
        };
      },
    },
  },
  data() {
    return {
      propertyAddress: { county_id: null },
      incomeLimits: [],
      qualifiesForProxy: false,
    };
  },
  computed: {
    ...mapState('App', {
      env: state => state.env,
    }),
    taxYear() {
      return this.program.settings['income-tax-year']
    },
    incomeText() {
      let content = this.program.settings['prequal-income-text']
      if (!content)
        return ''
      return content.replace('{year}', this.taxYear)
    }
  },
  mounted() {
    const focusableElements = (UIkit.Utils || UIkit.util).findFocusables(document.getElementById("pre-qual-questions"));

    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  },
  methods: {
    updatePropertyAddress(newValue) {
      this.propertyAddress = Vue.util.extend({}, newValue)
      this.getIncomeLimits();
      this.checkForProxy();
      this.$emit("addressVerified", newValue);
    },
    async getIncomeLimits() {
      if(this.program.settings['uses-hud-api-for-income-values']) {
        let r = await axios.get(`/api/programs/${this.program.id}/lmi/${this.propertyAddress.county_id}`);
        this.incomeLimits = [];
        let number = 1;
        _.each(r.data[this.program.settings['income-limit-chart-ami-used']], (limit, i) => {
          this.$set(this.incomeLimits, number, limit);
          number++;
        });
      }else if(this.program.settings['uses-income-limits-for-income-values']) {
        let r = await axios.get(`/api/programs/${this.program.id}/income-limits/${this.propertyAddress.county_id}`)
        if(r.data.incomeLimits.length) {
          _.each(r.data.incomeLimits, limit => {
            this.$set(this.incomeLimits, limit.household_size, limit.max_income);
          })
        }else {
          // Nothing Found
        }
      }
    },
    async checkForProxy() {
      let addressString = [
        this.propertyAddress.line_1,
        this.propertyAddress.city,
        this.states[this.propertyAddress.state],
        this.propertyAddress.zip,
      ].join('+');
      let r = await axios.get(`/api/programs/${this.program.id}/qct?address=${addressString}`)
      if(r.data.qualifies) {
        this.qualifiesForProxy = r.data.qualifies;
        this.$emit('proxyUpdated', r.data.qualifies);
      }
    }
  },
};
</script>
